<onyx-badge [color]="status().badgeColor" [size]="20">
  {{ status().name | translate }}
</onyx-badge>

@if (driver().skills.experienceLevel; as experienceLevel) {
  <span>·</span>

  <div class="item">
    <onyx-icon class="rating" name="rating-filled" [size]="12"></onyx-icon>

    {{ experienceLevel }}
  </div>
}

@if (
  driver().driverData.workPhone ?? driver().driverData.privatePhone;
  as phone
) {
  <span>·</span>

  <span class="item">{{ phone | onyxPhone }}</span>
}

@if (driver().driverData.assignedBase; as base) {
  <span>·</span>

  <onyx-link color="black" font="f-body-m" (click)="baseHelper.openModal(base)">
    {{ 'labels.base' | translate }} {{ base.name }}
  </onyx-link>
}
